export default {
    name: "Show",
    title: "Show",
    icon: "mdi-eye-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            container: null,
        };
    },
};